import { isViewVisible } from "../utils/ViewSettings";

export default () => {
  let links_map = {
    reservationsList: {
      url: "/reservations/reservationsList",
      icon: "fi fi-list-thumbnails",
      //actionLink: 'viewReservationsList',
      isAccessible: isViewVisible("reservationsList"),
    },
  };

  links_map.orders = {
    url: "/reservations/orders",
    icon: "fi fi-list",
    //actionLink: 'write'
    //actionLink: 'viewOrders',
    isAccessible: isViewVisible("orders"),
  };

  links_map.calendar = {
    url: "/reservations/calendar",
    icon: "fi fi-calendar",
    //actionLink: 'write',
    isAccessible: isViewVisible("calendar"),
  };

  return links_map;
};
